import React, { ReactElement } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import { ITemplate } from '../../interfaces/Template'
import { welcomeBg } from '../../assets/images/images'

function WelcomeTemplate({ children }: ITemplate): ReactElement {
  return (
    <>
      <Header isLogoutButtonVisible={false} />
      <div
        className="containerFluid px6md miw0 flexGrow1 welcomeBg p"
        style={{ backgroundImage: `url(${welcomeBg})` }}
      >
        <div className="row pt3 relative">{children}</div>
      </div>
      <Footer />
    </>
  )
}

export default WelcomeTemplate
